import Model from '../Model';
import WikiLabelOptions from './WikiLabelOptions';
import Mithril from 'mithril';

export default class WikiLabelOptionsSon extends Model {
  parentId() {
    return Model.attribute<number>('parentId').call(this);
  }
  icon() {
    return Model.attribute<string>('icon').call(this);
  }
  name() {
    return Model.attribute<string>('name').call(this);
  }
  sortCount() {
    return Model.attribute<number>('sortCount').call(this);
  }
  status() {
    return Model.attribute<boolean>('status').call(this);
  }

  link() {
    return Model.attribute<string>('link').call(this);
  }

  subName() {
    return Model.attribute<string>('subName').call(this);
  }

  subIcon() {
    return Model.attribute<string>('subIcon').call(this);
  }

  wikiLabelOptions() {
    return Model.attribute<WikiLabelOptions>('wikiLabelOptions').call(this);
  }

}
